import { GLDistributionTable } from "../../GLDistributionTable";
import { Button, Checkbox, DataHeader, DataSource, Layout, Panel, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOfficePayAdjustmentHistory extends Layout {
    buttonViewCommissionsHistory: Button;
    checkboxIsVoid: Checkbox;
    dataheaderPayAdjustment: DataHeader;
    layoutGLDistribution: GLDistributionTable;
    panelDetails: Panel;
    panelSourceCurrency: Panel;
    sourceJournalOffice: DataSource;
    sourceOffDeductHist: DataSource;
    tabAccounting: Tab;
    tabComments: Tab;
    tabGLDistribution: Tab;
    tabPayDetails: Tab;
    tabsetPayAdjustments: Tabset;
    textboxAmount: Textbox;
    textboxCheckDate: Textbox;
    textboxCheckNumber: Textbox;
    textboxCurrency: Textbox;
    textboxDeductCodeId: Textbox;
    textboxDeductionType: Textbox;
    textboxDescr: Textbox;
    textboxEmployerTaxLiab: Textbox;
    textboxGlid: Textbox;
    textboxPayeeId: Textbox;
    textboxRate: Textbox;
    textboxReferenceNo: Textbox;
    textboxShortDesc: Textbox;
    textboxSourceAmount: Textbox;
    textboxSourceCurrency: Textbox;
    textboxSourceId: Textbox;
    textboxTaxCode: Textbox;
    textboxTaxType: Textbox;
    textboxTransactionDate: Textbox;
    textboxUnits: Textbox;
    textboxVoidDate: Textbox;
}
